// DOM Content Loaded
document.addEventListener('DOMContentLoaded', function() {  

  function ksHandleErrorMessage(errorMessage = false) {
    let errorMessageWrapper = document.querySelector('.product-form__error-message-wrapper-recs');
    if (!errorMessageWrapper) return;
    
    let errorFormMessage = errorMessageWrapper.querySelector('.product-form__error-message-recs');
    errorMessageWrapper.toggleAttribute('hidden', !errorFormMessage);
    
    if (errorMessage) {
      errorFormMessage.textContent = errorMessage;
    }
  }
 
  const radioButtons = document.querySelectorAll('.reco-on-color-change');

  radioButtons.forEach(function (radioButton, index) { 
  const currentIndex = index + 1;
    radioButton.addEventListener('change', function (event) {
     
      document.querySelector('.product-form__error-message-wrapper-recs').setAttribute("hidden", true);
      const fieldsetFirst = Array.from(radioButton.querySelectorAll('fieldset'));
      const optionsFirst =  Array.from(radioButton.querySelectorAll('select'), (select) => select.value); 
      let variantDataFirst = JSON.parse(document.querySelector(`[product_recs="application/prod_recs_${currentIndex}"]`).textContent);
      let currentVariantFirst = variantDataFirst.find((variant) => {
        return !variant.options.map((option, index) => {
          return optionsFirst[index] === option;
        }).includes(false);
      });
      if (!currentVariantFirst) return;

      const inputFirst = document.querySelector(`input[name="prod_recs_${currentIndex}"]`); 
      inputFirst.value = currentVariantFirst.id;


      let bundleFirstElem = document.querySelector('.disabled-'+currentVariantFirst.id);

      if(bundleFirstElem.getAttribute('data-inventory') == 'pre-order') {
        let bundleAddToCart = document.getElementById(`prod_recs_add_text_${currentIndex}`);
        bundleAddToCart.innerText = 'Pre-Order Now';
        //document.getElementById("vitals-preorder-note").style.display = 'block';
      } else if(bundleFirstElem.getAttribute('data-inventory') == 'sold-out') {
        let bundleAddToCart = document.getElementById(`prod_recs_add_text_${currentIndex}`);
        bundleAddToCart.innerText = 'Sold out';
      } else {
        let bundleAddToCart = document.getElementById(`prod_recs_add_text_${currentIndex}`);
        bundleAddToCart.innerText = 'Add to bag';
      }
        
      //inputFirst.dispatchEvent(new Event('change', { bubbles: true }));
      //const colorNameFirst = document.querySelector('.color_name_first');
      //if (colorNameFirst !== null) {
        //colorNameFirst.innerHTML = currentVariantFirst.option1; 
      //}
    });
  });

  const colorButtons = document.querySelectorAll('.reco-radio-change');
  colorButtons.forEach(function (colorButton) {
    colorButton.addEventListener('click', function () {
      const selectedValue = colorButton.getAttribute('data-handle'); 
      
      var allDivs = document.querySelectorAll('.reco-color-size');
        allDivs.forEach(function(div) {
        div.style.display = 'none';
      });
      colorButtons.forEach(function(button) {
        button.classList.remove('active');
      });

      //colorButton.classList.add('active');
      var div = document.getElementById('reco-id-'+selectedValue);
      if (div) {
        div.style.display = 'block'; 
      }

    });
  });

  var elements = document.querySelectorAll('.recommendation_prod_add');
  elements.forEach(function(element) {
    element.addEventListener('click', function() {
      var index = element.getAttribute('data-index'); 
      var productId = element.getAttribute('data-id');
      document.querySelector('.product-form__error-message-wrapper-recs').setAttribute("hidden", true);
      element.classList.add('disabled', 'loading');
      
      const getInputFirst = document.querySelector('input[name="prod_recs_' + index + '"]');

      // Checking Out-of-Stock
      var forceCheckFirst = $('.disabled-prod-recs-'+index+' .disabled-'+getInputFirst.value); 
      if(forceCheckFirst.text() == 'disabled') {
        ksHandleErrorMessage("The product '"+forceCheckFirst.attr('data-name')+"' is already sold out.");
        element.classList.remove('disabled', 'loading');
        return;
      }
      
      let formData = {
        'items': [{
          'id': getInputFirst.value,
          'quantity': 1,
          'properties': {
            'Note': (forceCheckFirst.attr('data-inventory') == 'pre-order') ? 'Pre-order' : ''
          }
        }]
      };

      // Add Item to Cart
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .then((response) => {

        const cart = document.querySelector('cart-notification');
        if (response.status) { 
          document.getElementById('recommendation_prod_add').classList.remove('disabled', 'loading');
          return;
        } else if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        var html = '';
        var ids = [];
        response.items.map((item => {
          ids.push("'"+item.key+"'");
          var note = '';
          if(item.properties.Note !== '') {
            var note = '<div class="product-option"><dt>Note: </dt><dd>'+item.properties.Note+'</dd></div>';
          }
          html += '<div class="bundle-popup-items"><img class="cart-notification-product__image" src="'+item.featured_image.url+'" alt="'+item.product_title+'" loading="lazy" width="70" height="93"><div><h3 class="cart-notification-product__name h4">'+item.product_title+'</h3><dl><div class="product-option"><dt>'+item.options_with_values[0].name+': </dt><dd>'+item.options_with_values[0].value+'</dd></div>'+note+'</dl></div></div>'; 
        }));

        document.getElementById('cart-notification-product').innerHTML = html;
        
        fetch(window.Shopify.routes.root + 'cart.js', {
          method: 'GET', 
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(response => {  
          return response.json();
        })
        .then((response) => {
          document.getElementById('cart-notification-button').innerHTML = 'View my cart ('+response.item_count+')';
          if($('#cart-icon-bubble').find('span').length == 1) {
              $('#cart-icon-bubble').append('<div class="cart-count-bubble"><span aria-hidden="true">'+response.item_count+'</span><span class="visually-hidden">'+response.item_count+' items</span></div>');
          } else {
            $('#cart-icon-bubble .cart-count-bubble').html('<span aria-hidden="true">'+response.item_count+'</span><span class="visually-hidden">'+response.item_count+' items</span>');
          }
        });
        element.classList.remove('disabled', 'loading');
      });
      return true;
    });
  });
});


  



